module.exports = __webpack_public_path__ + "static/getStarted_chronic_mobile-c8cccfc78973cb1a019d7c861efe5b1e.svg";